import { EventEmitter, Injectable, Output, } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class InjectableService {

  @Output() disparadorEmpresa: EventEmitter<any> = new EventEmitter();
  @Output() disparadorMoneda: EventEmitter<any> = new EventEmitter();
  @Output() disparadorTipoCartera: EventEmitter<any> = new EventEmitter();
  @Output() disparadorTasas: EventEmitter<any> = new EventEmitter();
  @Output() disparadorConcepto: EventEmitter<any> = new EventEmitter();
  @Output() disparadorInvestigacion: EventEmitter<any> = new EventEmitter();
  @Output() disparadorVariables: EventEmitter<any> = new EventEmitter();

  constructor() { }
}
